import { createSelector } from '@ngrx/store';
import * as fromReducers from '../reducers';
import * as fromUpdatePaymentRuns from '../reducers/update-payment-run.reducer';

export const selectUpdatePaymentRunsResponse = createSelector(
  fromReducers.selectUpdatePaymentRunState,
  fromUpdatePaymentRuns.updatePaymentRunResponse
);

export const selectUpdatePaymentRunsLoaded = createSelector(fromReducers.selectUpdatePaymentRunState, state => state.loaded);

export const selectAddCreditCardFailure = createSelector(
  fromReducers.selectUpdatePaymentRunState,
  fromUpdatePaymentRuns.updatePaymentRunFailure
);
